import { Navigate, Outlet, useLocation } from "react-router-dom";
import { hasPersistedSession, readStoredSession, useAuth } from "../context/AuthContext";
import { canAccessModule, getLandingRouteForRole, hasUIAccess, ROUTE_MODULES } from "../config/rbacConfig";

function getRouteModule(pathname) {
  const match = Object.keys(ROUTE_MODULES)
    .sort((a, b) => b.length - a.length)
    .find((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
  return match ? ROUTE_MODULES[match] : null;
}

export default function ProtectedRoute() {
  const location = useLocation();
  const { isAuthenticated, permissions, user } = useAuth();
  const hasStoredSession = hasPersistedSession();
  const storedPermissions = hasStoredSession ? readStoredSession()?.permissions ?? [] : [];
  const canAccess = isAuthenticated || hasStoredSession;
  const effectivePermissions = permissions.length > 0 ? permissions : storedPermissions;

  if (!canAccess) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!hasUIAccess(user?.roleId)) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const moduleKey = getRouteModule(location.pathname);
  if (moduleKey && !canAccessModule(user, effectivePermissions, moduleKey)) {
    return <Navigate to={getLandingRouteForRole(user)} replace />;
  }

  return <Outlet />;
}
